/* eslint-disable react-hooks/exhaustive-deps */
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { authProtectedRouteList } from 'routes';
import { getAllowedRoutesAccordingPlan } from 'shared';
import { usePlan } from '../plans';
import { protectedRouteListAtom } from './app-config.state';

export const useAppConfigInit = () => {
  const [protectedRouteList, setProtectedRouteList] = useAtom(
    protectedRouteListAtom,
  );
  const { planInfo } = usePlan();

  useEffect(() => {
    const protectedRoutes = planInfo?.plan
      ? getAllowedRoutesAccordingPlan(authProtectedRouteList, planInfo)
      : authProtectedRouteList;

    setProtectedRouteList(protectedRoutes);
  }, [planInfo]);

  return {
    protectedRouteList,
  };
};
